import { MapDataProvider, useMapData } from "./useMapData"
import { useEffect, useRef } from "react"
import { DefaultMapBehavior } from "./handlers/default"
import { getInteractableLayerIds, MapSource } from "./handlers/source"
import { useMap } from "@ciq/shared/hooks/map"

export function Map() {
  return (
    <MapDataProvider>
      <View />
    </MapDataProvider>
  )
}

function View() {
  const ref = useRef(null)

  const { hasFetched, setMap } = useMapData()
  const { map, isLoading, setContainer } = useMap()

  // stable ref so useRef
  const setContainerRef = useRef(setContainer)

  useEffect(() => {
    if (!hasFetched || !ref.current) {
      return
    }

    setContainerRef.current(ref)
  }, [hasFetched])

  useEffect(() => {
    if (!map || isLoading) {
      return
    }

    setMap(map)
  }, [isLoading, map, setMap])

  const boxZoomEnabled = map?.boxZoom.isEnabled()
  const keyboardEnabled = map?.keyboard.isEnabled()

  useEffect(() => {
    if (!map || isLoading) {
      return
    }

    if (!boxZoomEnabled) {
      map.boxZoom.enable()
    }

    if (!keyboardEnabled) {
      map.keyboard.enable()
    }
  }, [boxZoomEnabled, isLoading, keyboardEnabled, map])

  return (
    <div className="map-container" ref={ref}>
      <DefaultMapBehavior map={map} isMapLoading={isLoading} layerIds={getInteractableLayerIds()} />
      <MapSource map={map} isMapLoading={isLoading} />
    </div>
  )
}
